import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { LoginPagesLayout } from "@features/login/LoginPagesLayout";
import { ShowcasePageTitle } from "@components";
import { loadMyself } from "@api";
import { LoginSSOContent } from "./loginSSO";
import { LoginPageForm } from "./components/LoginPageForm";
import { LoginPageSignupQuestion } from "./components/LoginPageSignupQuestion";
import { TwoFAForm } from "./components/TwoFAForm";
import { TwoFAFormData } from "./types";

type Props = {
  showSSO?: boolean;
};

export const LoginPage = ({ showSSO = false }: Props) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [twoFAFormData, setTwoFAFormData] = useState<TwoFAFormData>();

  const navigateAfterLogin = (emailConfirm: boolean) => {
    if (emailConfirm) {
      const redirectUrl = searchParams.get("redirectUrl");

      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        navigate("/");
      }
    } else {
      navigate("/confirmation/email");
    }
  };

  const onLogin = async (access_token: string) => {
    const { isEmailConfirmed } = await loadMyself(access_token);

    navigateAfterLogin(isEmailConfirmed);
  };

  if (showSSO) {
    return (
      <LoginPagesLayout containerSx={{ maxWidth: "860px!important" }}>
        <LoginSSOContent onLogin={onLogin} />
      </LoginPagesLayout>
    );
  }

  return (
    <LoginPagesLayout>
      <ShowcasePageTitle
        title={t("loginPage.header.title")}
        subtitle={t("loginPage.header.subtitle")}
      />
      {twoFAFormData ? (
        <TwoFAForm
          onLogin={onLogin}
          twoFAFormData={twoFAFormData}
          goBack={() => setTwoFAFormData(undefined)}
        />
      ) : (
        <LoginPageForm setTwoFAFormData={setTwoFAFormData} onLogin={onLogin} />
      )}

      <LoginPageSignupQuestion />
    </LoginPagesLayout>
  );
};
